import useSentryUser from "@/hooks/sentry/useSentryUser";
import { Alert, AlertTitle, Button, Collapse, Grid2, Typography } from "@mui/material";
import { AuthenticatedUserContext } from "@ngt/opms";
import * as Sentry from "@sentry/react";
import { FC, useContext, useEffect, useState } from "react";
import { Link, useRouteError } from "react-router-dom";

const RouteErrorBoundary : FC = () => {
    const {loading: userLoading} = useContext(AuthenticatedUserContext);
    
    useSentryUser();
    const error = useRouteError() as Error;

    useEffect(() => {
        if(!userLoading) {
            Sentry.captureException(error);
        }
    }, [error, userLoading]);
    
    const [details, setDetails] = useState(false);

    return (
        <>
            <Alert
                sx={{
                    margin: 2,
                }}
                severity="error"
                slotProps={{
                    message: {
                        sx: {
                            width: "100%"
                        }
                    }
                }}
            >
                <AlertTitle>An error has occurred!</AlertTitle>
                <Typography gutterBottom>
                    Please refresh the page and try again.
                </Typography>
                {
                    error?.message && (
                        <Typography gutterBottom>
                            <strong>Error:</strong> <em>{error.message}</em>
                        </Typography>
                    )
                }
                <Grid2
                    container
                    sx={{
                        display: "flex",
                        justifyContent: "flex-end",
                        width: "100%"
                    }}
                    gap={2}
                >
                    <Grid2>
                        {
                            error?.stack && (
                                <>
                                    <Button onClick={() => setDetails(c => !c)}>
                                        More Details
                                    </Button>
                                </>
                            )
                        }
                    </Grid2>
                    <Grid2>
                        <Button
                            component={Link}
                            to={"/"}
                            variant="contained"
                        >
                            Home
                        </Button>
                    </Grid2>
                </Grid2>
                {
                    error?.stack && (
                    <Collapse in={details}>
                        <pre>
                            {error.stack}
                        </pre>
                    </Collapse>
                    )
                }
            </Alert>
        </>
    );
}

export default RouteErrorBoundary;